import React from 'react'
import { Option, decodeHTMLEntities, gtmPush } from '../../../helpers'
import { link, linkWrapper } from '../../cms/blocks/utils.gen'
import { WordPress, withDataState } from '../../wordpress/wordpress_api'

type MenuLocation = 'main' | 'top'

type Props = {
  location: MenuLocation
  hasActiveState: boolean
  before?: JSX.Element
  after?: JSX.Element
  cssClass?: string
  showDescription?: boolean
}

type State = withDataState<WordPress.MenuLocationResponse>

export default class MainNavItems extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      kind: 'loading'
    }
  }

  componentDidMount() {
    WordPress.findMenuByLocation(this.props.location)
      .then((response) => this.setState((s) => ({ ...s, kind: 'loaded', data: Option(response.data) })))
      .catch(() => this.setState({ kind: 'error' }))
  }

  render() {
    let classes = [
      'nav__list',
      this.props.cssClass ? `nav__list--${this.props.cssClass}` : `nav__list--${this.props.location}`
    ]

    if (this.state.kind != 'loaded') return <></>
    if (this.state.data.kind == 'none') return <></>

    if (this.props.location == 'top') {
      return (
        <>
          {this.state.data.value.map((menuItem: WordPress.MenuItem, index: number) => (
            <li key={`${this.props.location}-${index}`} className="nav__item nav__item--top">
              {link(
                linkWrapper({ title: menuItem.title, url: menuItem.url }),
                { classname: 'nav__link nav__link--top typo--xs' },
                menuItem.title,
                undefined,
                isLinkActive(menuItem.url) ? 'page' : undefined
              )}
            </li>
          ))}
        </>
      )
    }
    return (
      this.state.kind === 'loaded' &&
      this.state.data.kind === 'some' && (
        <>
          <ul className={classes.join(' ')}>
            {this.props.before}
            {this.state.data.value.map((menuItem: WordPress.MenuItem, index: number) => (
              <li
                key={`${this.props.location}-${index}`}
                className={`nav__item nav__item--${this.props.location} ${menuItem.classes}`}
              >
                {this.navItem(menuItem, () => {
                  if (this.props.location == 'main') {
                    gtmPush({
                      event: 'menu',
                      menu_type: 'main',
                      click_text: menuItem.title
                    })
                  }
                })}
              </li>
            ))}
            {this.props.after}
          </ul>
        </>
      )
    )
  }

  navItem(menuItem: WordPress.MenuItem, onClick?: () => void) {
    return link(
      linkWrapper({ title: menuItem.title, url: menuItem.url }),
      { classname: `nav__link nav__link--${this.props.location}` },
      <>
        {decodeHTMLEntities(menuItem.title)}
        {this.props.showDescription && (
          <>
            <div className="nav__description">{menuItem.description}</div>
            {menuItem.button_label}
          </>
        )}
      </>,
      onClick,
      isLinkActive(menuItem.url) ? 'page' : undefined
    )
  }
}

const isLinkActive = (url: string): boolean => {
  const currentPath = window.location.pathname
  return currentPath === url || currentPath.startsWith(url + '/')
}
